import { AxiosInstance } from 'axios';
import { gatewayAmazonConnect } from './gatewayAmazonConnect';
import { gatewayEventScheduler } from './gatewayEventScheduler';
import { gatewayPhone } from './gatewayPhone';
import { gatewaySectorWorkFlows } from './gatewaySectorWorkFlows';
import { gateway } from '../gateway';

export enum GatewayType {
  AMAZON_CONNECT = 'amazon_connect',
  EVENT_SCHEDULER = 'event_scheduler',
  FLOWNECT_MOBILE = 'flownect-mobile',
  SECTOR_WORKFLOWS = 'sector_workflows',
  LEGACY = 'legacy',
}

const GATEWAY_MAP: Record<GatewayType, AxiosInstance> = {
  [GatewayType.AMAZON_CONNECT]: gatewayAmazonConnect,
  [GatewayType.EVENT_SCHEDULER]: gatewayEventScheduler,
  [GatewayType.FLOWNECT_MOBILE]: gatewayPhone,
  [GatewayType.SECTOR_WORKFLOWS]: gatewaySectorWorkFlows,
  [GatewayType.LEGACY]: gateway,
};

export const getGateway = (gatewayType: GatewayType = GatewayType.LEGACY): AxiosInstance => {
  const gateway = GATEWAY_MAP[gatewayType];

  if (!gateway) {
    console.warn(`Gateway type "${gatewayType}" not found, using DEFAULT`);
    return GATEWAY_MAP[GatewayType.LEGACY];
  }

  return gateway;
};

/**
 * Obtiene el tipo de gateway para una app específica
 * Acepta tanto un string (appId) como un GatewayType (enum)
 */
export const getGatewayTypeForApp = (appId: string | GatewayType): GatewayType => {
  // Si ya es un GatewayType, retornarlo directamente
  if (Object.values(GatewayType).includes(appId as GatewayType)) {
    return appId as GatewayType;
  }

  // Si es un string, buscar en el map
  const gatewayMap: Record<string, GatewayType> = {
    'paypal': GatewayType.LEGACY,
    'amazon-connect': GatewayType.AMAZON_CONNECT,
    'event-scheduler': GatewayType.EVENT_SCHEDULER,
    'sector-workflows': GatewayType.SECTOR_WORKFLOWS,
    'sector_workflows': GatewayType.SECTOR_WORKFLOWS,
    'amazon_connect': GatewayType.AMAZON_CONNECT,
    'event_scheduler': GatewayType.EVENT_SCHEDULER,
    'flownect-mobile': GatewayType.FLOWNECT_MOBILE,
  };

  return gatewayMap[appId] || GatewayType.LEGACY;
};

export const getGatewayForApp = (appId: string | GatewayType): AxiosInstance => {
  const gatewayType = getGatewayTypeForApp(appId);
  return getGateway(gatewayType);
};